angular.module('smartorg.r6.mgmts.legalMessage').directive('legalMessageManage', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/legal-message-manage.html'),
            scope: {
                astro: '=?',
                showAlert: '&?'
            },
            link: function (scope) {
                /**
                 * Wrap the showAlert to a easier call.
                 *
                 * @param type
                 * @param title
                 * @param message
                 */
                var showMessage = function (type, title, message) {
                    scope.showAlert({
                        type: type,
                        title: title,
                        message: message
                    });
                };
                // Create a alert method if not passed in.
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        alert(input.message);
                    };
                }
                // Check api status
                if (!scope.astro) {
                    showMessage('danger', 'System Error', 'Failed to load API.');
                }
                scope.current = {
                    message: "",
                    messageState: 0
                };
                /**
                 * Can only be LICENSE or SECURITY_WARNING_WB.
                 * @type {string}
                 */
                scope.messageType = "";
                scope.setOrigin = function (message, state) {
                    scope.origin = {
                        message: message,
                        messageState: state
                    };
                    scope.current.message = message;
                    scope.current.messageState = state;
                };
                scope.loadMessage = function () {
                    if (scope.messageType === 'LICENSE') {
                        scope.messageTypeDisplay = "Legal Agreement";
                    }
                    else if (scope.messageType === 'SECURITY_WARNING_WB') {
                        scope.messageTypeDisplay = "Security Warning Message";
                    }
                    else {
                    }
                    scope.astro.getWelcomeMessage(scope.messageType).then(function (rs) {
                        if (rs['status'] && rs['status'] === 1) {
                            scope.setOrigin("", 0);
                        }
                        else {
                            scope.setOrigin(decodeURIComponent(atob(rs.data.config.message)), rs.data.config.state);
                        }
                        $timeout();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                scope.saveMessage = function () {
                    scope.astro.setWelcomeMessage(scope.messageType, btoa(encodeURIComponent(scope.current.message)), scope.current.messageState).then(function () {
                        scope.setOrigin(scope.current.message, scope.current.messageState);
                        showMessage('success', "Success!", "Data saved.");
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                scope.$on("manage:LEGAL_MESSAGE", function (event, args) {
                    scope.messageType = args.messageType;
                    scope.loadMessage();
                });
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=legal-message-manage-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/legal-message/app/js/plumbing/legal-message-manage-directive.js